import useXSearchMultiSelect from './useXSearchMultiSelect';
import XButton from './XButton';

const wrapperClasses = 'mb-3 w-full';

const labelClasses = 'block mb-2 text-content';

const inputClasses = `w-full h-10
  bg-white border border-border rounded-md
  px-3 py-1.5 text-base text-content
  focus:outline-none focus:ring-2 focus:ring-primary-ring`;

const dropdownPanelClasses = `absolute left-0 right-0 z-10
  mt-1 bg-surface border border-border-light
  rounded-md shadow-md overflow-hidden
  max-h-56 overflow-y-auto`;

const optionRowClasses = `flex items-center gap-2
  px-3 py-2 cursor-pointer
  transition-colors duration-150
  hover:bg-primary hover:text-white`;

const optionCheckboxClasses = '';

const noMatchesClasses = 'px-4 py-2 text-subtle text-center';

const tagsRowClasses = 'flex flex-wrap gap-2 mt-2';

const tagClasses = `inline-flex items-center
  bg-disabled text-white
  rounded-md px-2 py-1
  text-xs font-bold leading-none`;

const tagRemoveClasses = 'ml-2! p-0! text-white! hover:text-white!';

const tagRemoveIconClasses = 'fa fa-times text-white';

const dropdownAnchorClasses = 'relative';

const XSearchMultiSelect = ({
    value,
    onChange,
    label,
    items,
    onSearch,
    getItemLabel,
    placeholder = 'Search or add...',
}) => {
    const {
        inputValue,
        showDropdown,
        dropdownRef,
        handleChange,
        openDropdown,
        toggleItem,
        removeItem,
        handleKeyDown,
    } = useXSearchMultiSelect({ onSearch, value, onChange });

    const selected = Array.isArray(value) ? value : [];

    return (
        <div className={wrapperClasses}>
            {label && <label className={labelClasses}>{label}</label>}

            <div className={dropdownAnchorClasses} ref={dropdownRef}>
                <input
                    type="text"
                    className={inputClasses}
                    placeholder={placeholder}
                    value={inputValue}
                    onFocus={openDropdown}
                    onChange={(e) => handleChange(e.target.value)}
                    onKeyDown={(e) => handleKeyDown({ e, items })}
                />

                {showDropdown && (
                    <div className={dropdownPanelClasses}>
                        {items.length > 0 ? (
                            items.map((item) => {
                                const isSelected = selected.some((v) => v._id === item._id);
                                return (
                                    <div
                                        key={item._id}
                                        className={optionRowClasses}
                                        onClick={() => toggleItem({ item })}
                                    >
                                        <input
                                            type="checkbox"
                                            className={optionCheckboxClasses}
                                            checked={isSelected}
                                            readOnly
                                        />
                                        <span>{getItemLabel(item)}</span>
                                    </div>
                                );
                            })
                        ) : (
                            <div className={noMatchesClasses}>No matches found.</div>
                        )}
                    </div>
                )}
            </div>

            <div className={tagsRowClasses}>
                {selected.map((item) => (
                    <div key={item._id} className={tagClasses}>
                        {getItemLabel(item)}
                        <XButton
                            variant="close"
                            onClick={() => removeItem({ item })}
                            className={tagRemoveClasses}
                            aria-label={`Remove ${getItemLabel(item)}`}
                        >
                            <i className={tagRemoveIconClasses} />
                        </XButton>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default XSearchMultiSelect;
